import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  size: PropTypes.string,
};

const FirefoxIcon = ({ size = '32', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-label="Firefox"
    viewBox="0 0 512 512"
    width={size}
    {...props}
  >
    <rect width="512" height="512" rx="15%" fill="#fff" />
    <linearGradient id="a" x1=".7" x2=".3" y2=".8">
      <stop offset=".3" stopColor="#fd5" />
      <stop offset=".6" stopColor="#f85" />
      <stop offset="1" stopColor="#d06" />
    </linearGradient>
    <radialGradient id="b" cx=".4" cy=".7">
      <stop offset=".4" stopColor="#74d" />
      <stop offset="1" stopColor="#a2d" />
    </radialGradient>
    <linearGradient id="c" x1=".8" y1=".2" x2=".4" y2=".8">
      <stop offset=".2" stopColor="#fd5" />
      <stop offset="1" stopColor="#f33" />
    </linearGradient>
    <g transform="scale(4)">
      <path
        d="M48 49s-3-9-1-16c-9 2-33 35-33 35a51 48 0 1 0 87-32s5 9 5 15c-3-9-20-25-26-37-24 13-16 39-16 39"
        fill="url(#a)"
      />
      <circle cx="64" cy="67" r="26" fill="url(#b)" />
      <path
        d="m21 45 43 12c-6 11-16 3-23 14a22 22 0 1 0 34-20s33 3 17 42H28m36 25h1"
        fill="url(#a)"
      />
      <path
        d="M35 43c16 0 12 7 29 14-18 6-23-9-38 0 5 9 12 8 12 8 1 43 72 29 67-17a50 46.6 47 0 1-88 33c-9-18-1-40 16-51"
        fill="url(#c)"
      />
    </g>
  </svg>
);

FirefoxIcon.propTypes = propTypes;

export default FirefoxIcon;
